import axios from 'axios';

export async function disableSmsMfa() {
  await axios.post(`/api/?entity=twoFactorAuthentication&action=sms2faDisable`);
}
